import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';

// Caps the Name/Description column so long descriptions wrap instead of stretching the table.
const NAME_CONTENT_MAX_WIDTH = 300;
// Readable line-width cap for the header description copy.
const HEADER_COPY_MAX_WIDTH = 800;

export const styleSheet = StyleSheet.create({
	card: {
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		boxShadow: '0px 0px 6px rgba(139, 139, 139, 0.1)',
		marginBottom: THEME.spacing.lg,
		marginTop: THEME.spacing.lg,
		overflow: 'hidden',
	},
	clientIdCell: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.md,
	},
	clientIdValue: {
		fontFamily: 'monospace',
	},
	container: {
		display: 'flex',
		flexDirection: 'column',
	},
	createdBy: {
		color: THEME.colors.text.light,
		display: 'block',
		fontSize: THEME.typography.fontSizes.xs,
	},
	description: {
		color: THEME.colors.text.light,
		display: 'block',
		fontSize: THEME.typography.fontSizes.xs,
		marginTop: 2,
	},
	docsFooter: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.xs,
		justifyContent: 'center',
		marginTop: THEME.spacing.lg,
		padding: THEME.spacing.lg,
	},
	header: {
		alignItems: 'flex-start',
		display: 'flex',
		justifyContent: 'space-between',
		marginTop: THEME.spacing.xl,
	},
	headerCopy: {
		maxWidth: HEADER_COPY_MAX_WIDTH,
	},
	headerActions: {
		flexShrink: 0,
		padding: THEME.spacing.md,
	},
	nameCell: {
		verticalAlign: 'top',
	},
	nameContent: {
		maxWidth: NAME_CONTENT_MAX_WIDTH,
		wordBreak: 'break-word',
	},
	redirectUri: {
		fontSize: THEME.typography.fontSizes.xs,
		wordBreak: 'break-all',
	},
	redirectUris: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
	scopes: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
});
